<cluster-plan-tree-element
  *ngFor="let child of plan | keyvalue"
  [element]="child.key"
  [(plan)]="plan[child.key]"
>
</cluster-plan-tree-element>
